import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuthStore } from '../../hooks/useAuth';

interface Props {

}

const AdminRoute = ({ component, ...rest }: any) => {
  const { isAdmin } = useAuthStore();
  return (
    <Route
      {...rest}
      render={props =>
        isAdmin ? (
          React.createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default AdminRoute;
